(function () {
  function hydrateMessage(message, count) {
    if (!message) return;

    var countNode = message.querySelector('[data-inventory-count]');
    if (countNode) {
      countNode.textContent = count;
      return;
    }

    var walker = document.createTreeWalker(message, NodeFilter.SHOW_TEXT);
    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('{count}') !== -1) textNodes.push(node);
    }

    textNodes.forEach(function (textNode) {
      var parts = textNode.nodeValue.split('{count}');
      var fragment = document.createDocumentFragment();

      parts.forEach(function (part, index) {
        if (part) fragment.appendChild(document.createTextNode(part));
        if (index < parts.length - 1) {
          var replacement = document.createElement('span');
          replacement.setAttribute('data-inventory-count', '');
          replacement.textContent = count;
          fragment.appendChild(replacement);
        }
      });

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function update(root, count) {
    if (!root) return;
    var messages = root.matches && root.matches('[data-inventory-message]')
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll('[data-inventory-message]'));
    messages.forEach(function (message) {
      hydrateMessage(message, count);
    });
  }

  function initialize(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var messages = scope.matches && scope.matches('[data-inventory-message]')
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll('[data-inventory-message]'));
    messages.forEach(function (message) {
      update(message, message.dataset.inventoryCountValue || '');
    });
  }

  window.AxiomInventoryMessage = { initialize: initialize, update: update };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
